var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle210(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "146.1930425034837 516.0774174309364 20.807227715624975 21.063328706445645",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M163,526.49c-.09,3.86-1.59,5.49-4.81,5.95-1.11.16-2.22.34-3.32.57-2.43.51-4.15-.48-4.54-2.83-.53-3.2.51-6.05,2.57-8.43,1.7-1.98,4.49-2.17,6.76-.74,2.27,1.43,3.36,3.53,3.34,5.47Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle210);
export default __webpack_public_path__ + "static/media/twinkle-2-10.2fcf9075194d53ff0e62444715c5a47f.svg";
export { ForwardRef as ReactComponent };